import * as yup from 'yup'

export const schema = yup.object().shape({
  responsibleName: yup.string().required(),
  responsibleEmail: yup.string().email().required(),
  responsiblePhone: yup.string().phone({ required: true }),
})

export default schema
